import { IVideo } from '@connec10/media-interface/src/entity'
import React, { useMemo } from 'react'
import { convertPeriodToDisplayString } from '../../../libs'
import { Box } from '../../atoms'
import { CourseListItem } from '../../molecules'

export interface courseProps {
  courseList: IVideo[]
  currentId: string
}

export const Playlist = ({ courseList, currentId }: courseProps) => {
  //- sortIndex 順に並び替え
  const sortedCourseList = useMemo(() => {
    courseList.sort((a: IVideo, b: IVideo): number => {
      return a.sortIndex - b.sortIndex
    })
    return courseList
  }, [courseList])

  return (
    <Box color="black">
      {sortedCourseList.map((course, i) => {
        return (
          <Box key={i} mb="4px">
            <CourseListItem
              id={course.id}
              title={course.title}
              index={course.sortIndex}
              tagName={convertPeriodToDisplayString(course.term.period, course.term.displayName)}
              active={currentId === course.id}
            />
          </Box>
        )
      })}
    </Box>
  )
}
